// @flow

import * as React from 'react';

/** @jsx jsx */
import { jsx } from '@emotion/core';

import ClickPropagationBarrier from '../ClickPropagationBarrier';
import KeydownPropagationBarrier from '../KeydownPropagationBarrier';

const InputPropagationBarrier = ({
  children,
  className,
}: {
  children: React.Node,
  // allows usage of CSS prop
  className?: string,
}) => {
  return (
    <ClickPropagationBarrier className={className}>
      <KeydownPropagationBarrier className={className}>
        {children}
      </KeydownPropagationBarrier>
    </ClickPropagationBarrier>
  );
};

export default InputPropagationBarrier;
